import { Injectable, EventEmitter, Output } from '@angular/core'
import { userSearchPipe } from "../pipe/userSearchPipe";
import { Subscription, Subject, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { Router, RouterLink } from "@angular/router";
import { HttpService } from './http.service';
import { CustomHttpClientService } from './custom-http-client.service';
import { timer } from 'rxjs';

declare var $:any;
@Injectable()
export class eventEmitterService {

   public eventEmit$: EventEmitter<any> = new EventEmitter();
   public alert$: EventEmitter<any> = new EventEmitter();
   public replyCount$: EventEmitter<any> = new EventEmitter();
   public commentCount$: EventEmitter<any> = new EventEmitter();
   page;
   private timer;
   private groupsTimer;
   private sub: Subscription;
   public _msgCount$: Subject<{}>;
   private url = environment.apiUrl;
   private totalCount = { getAllMsgCount : 0 , getAllGroupMsgCount : 0 , getAllGroupsCount : 0 };
   token = localStorage.getItem('token')

   constructor(private userSearch : userSearchPipe, private http: CustomHttpClientService, private router: Router, private httpService: HttpService, ) {

     this._msgCount$ = <Subject<{}>>new Subject();
     //this.defaultHeaderInfo();
     router.events.subscribe((data:any) => { this.page = data.url } );

     this.timer = timer(500, 6000);
     //this.groupsTimer = Observable.timer(500,1000);
    
     //setTimeout(()=> {
        if(this.httpService.isLocalAuthenticated()){
            this.getAllCounts('all')
            //this.sub = this.timer.subscribe(t => { this.getAllCounts() });           
          }
           //this.groupsTimer.subscribe(timer => { this.getAllGroupsUnreadMsgCount() });
     //},500);
   }

   triggerSocketService(type){
        if(this.httpService.isLocalAuthenticated()){
            this.getAllCounts(type)
        }
   }

   get msgCount$() {
     return this._msgCount$.asObservable();
   }

   setMessageCount(){
       return this._msgCount$.next(0)
   }

   newProfileImage(newProfileImage){
       this.eventEmit$.emit(newProfileImage);
   }

   open(user){
      var windowWidth = $(window).innerWidth();
      if(windowWidth < 992){
          this.router.navigate(['/messages'], {queryParams: {user: user.id, fname : user.firstName, lname : user.lastName }});
      }else{
        this.eventEmit$.emit({isOpenChat: true, user: user});
      }
   }
   openPopup(open){
      this.eventEmit$.emit(open);
   }

   removedUser(userId){
       this.eventEmit$.emit({ removedUser : userId });
   }

   filterUser(allUsers: any, field: string, value: any){
       return this.userSearch.transform(allUsers, field, value);
   }

   filterGroup(allUsers: any, field: string, value: string){
       return this.userSearch.transformGroup(allUsers, field, value);
   }

   filterBuilding(filterBuilding){
       this.eventEmit$.emit(filterBuilding);
   }

   createGroup(){
      this.eventEmit$.emit(true);
   }

   newMessage(newMsg){
      this.eventEmit$.emit(newMsg);
   }

   totalMsgCount(total){
      this.eventEmit$.emit({totalMsg : total});
   }

   totalGroupMsgCount(total){
     this.eventEmit$.emit({totalGroupMsg : total});
   }

   getAllGroupsUnreadMsgCount(){
       var buildings = [];
       var buildingsFilter = false;
       $("#all_building_drp div.checkbox_inputs").find("input[type='checkbox']").each(function(){
          if($(this).is(':checked')){
            var buildingId = $(this).val();
            buildings.push(buildingId);
          }
       });

       var page = 'groups';
       var allGroupsBuildings = buildings;

       self["io"].socket.get('/group/getAllGroupMsgCount', { page : 'groups', buildings : allGroupsBuildings, buildingsFilter : buildingsFilter, extraHeaders: {authorization: this.token}});
             
       self["io"].socket.on('getAllGroupMsgCount', (totalMsg) => {
            this.totalCount.getAllGroupMsgCount = totalMsg.getAllGroupMsgCount;
       });
       setTimeout( ()=> {
        if(this.totalCount){
            this._msgCount$.next(this.totalCount);
        }
       },100);
   }

   getAllCounts(type){
        //this._msgCount$.next(this.totalCount);
        var buildings = [];
        var buildingsFilter = false;

        $("#all_building_drp div.checkbox_inputs").find("input[type='checkbox']").each(function(){
            if($(this).is(':checked')){
               var buildingId = $(this).val();
               buildings.push(buildingId);
            }
        });
        
        var page = '';
        var msgBuildings = [];
        var groupBuildings = [];
        var allGroupsBuildings = [];

        if(this.page == '/groups' || this.page == 'groups'){
           page = 'groups';
           groupBuildings = buildings;
        }else if(this.page == '/messages' || this.page == 'messages'){
           page = 'messages';
           msgBuildings = buildings;
        }
        else if(this.page == '/allgroups' || this.page == 'allgroups'){
           page = 'allgroups';
           allGroupsBuildings = buildings;
        }

        if(type === 'message'){
            self["io"].socket.get('/message', { page : 'messages', buildings : msgBuildings, buildingsFilter : buildingsFilter, extraHeaders: {authorization: this.token}});        
            self["io"].socket.get('/message', { page : 'chat', buildings : [], buildingsFilter : buildingsFilter, extraHeaders: {authorization: this.token}});
        
        }else if(type === 'groupMsg'){
            self["io"].socket.get('/group', { page : 'groups', buildings : groupBuildings, buildingsFilter : buildingsFilter, extraHeaders: {authorization: this.token}});
            self["io"].socket.get('/group/allresidentsgroups', { page : 'allgroups', buildings : allGroupsBuildings, buildingsFilter : buildingsFilter, extraHeaders: {authorization: this.token}});
    
            self["io"].socket.get('/group/getAllGroupMsgCount', { page : 'groups', buildings : groupBuildings, buildingsFilter : buildingsFilter,extraHeaders: {authorization: this.token}});
        }else if(type === 'all'){
            self["io"].socket.get('/feed');
            self["io"].socket.get('/message', { page : 'messages', buildings : msgBuildings, buildingsFilter : buildingsFilter, extraHeaders: {authorization: this.token}});        
            self["io"].socket.get('/message', { page : 'chat', buildings : [], buildingsFilter : buildingsFilter, extraHeaders: {authorization: this.token}});

            self["io"].socket.get('/group', { page : 'groups', buildings : groupBuildings, buildingsFilter : buildingsFilter, extraHeaders: {authorization: this.token}});
            self["io"].socket.get('/group/allresidentsgroups', { page : 'allgroups', buildings : allGroupsBuildings, buildingsFilter : buildingsFilter, extraHeaders: {authorization: this.token}});
            self["io"].socket.get('/group/getAllGroupMsgCount', { page : 'groups', buildings : groupBuildings, buildingsFilter : buildingsFilter, extraHeaders: {authorization: this.token}});
            

        }
        
            
        self["io"].socket.on('getAllMsgCount', (totalMsg) => {  
            this.totalCount.getAllMsgCount = totalMsg.getAllMsgCount;  
        });

        self["io"].socket.on('getAllGroupMsgCount', (totalMsg) => {
            this.totalCount.getAllGroupMsgCount = totalMsg.getAllGroupMsgCount;
        });

        self["io"].socket.on('allresidentsgroups', (groups) => {
            this.totalCount.getAllGroupsCount = groups.getAllGroupsCount;
        });

        setTimeout( ()=> {
            //console.log(totalCount);
            if(this.totalCount){
                this._msgCount$.next(this.totalCount);
            }
        },500);

   }


   totalUnreadBuildingAlertCount(total){
     this.eventEmit$.emit({totalAlerts : total});
   }

   getNextFeedsForLazyLoad(feeds){
     this.eventEmit$.emit({
       nextFeeds: feeds
     });
   }

   replaceBuildingByRes(replacedBuilding){
     this.eventEmit$.emit({ replaceBuildingByRes : replacedBuilding });
   }

   removeGroup(group) {
     this.eventEmit$.emit({removeGroup: group});
   }

   openGroup(group){
      this.router.navigate(['/groups'], {queryParams: { openGroup : true , groupId: group.id }});
   }

}
